import React, { useContext, createContext, useState } from "react";

const AuthContext = createContext();

const AuthProvider = (props) => {
  const [authState, setAuthState] = useState(
    JSON.parse(localStorage.getItem("userData"))
  );
  /* const [isAuth, setIsAuth] = useState(false); */

  /* useState(() => {
    console.log(isAuth);
  }, [isAuth]); */

  return (
    <AuthContext.Provider value={{ authState, setAuthState }}>
      {props.children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };
